import * as React from "react";
import { Row, Spin } from 'antd';
import Form, { FormComponentProps, WrappedFormUtils } from 'antd/lib/form/Form';
import { useContext, useEffect, useState } from 'react';
import { ITrade } from 'src/services/interfaces/trade/ITrade';
import StandardButton from '../StandardButton/StandardButton';
import * as _ from 'lodash';
import { CommissionSliderComponent } from "src/components/PricingComponents/CommissionSliderComponent/CommissionSliderComponent";
import { IPricingUpdateRequest } from "src/services/interfaces/calculator/ISpecialProjectPricingUpdateRequest";
import { ServiceContext } from "src/services/provider/Service.provider";
import { ShowNotification } from "../ShowNotification/ShowNotification";


interface ICommissionBodyProps {
    currentTrade: ITrade;
    onCommissionUpdated: (trade: ITrade) => void
    form: WrappedFormUtils;
}

export const CommissionBody: React.FC<ICommissionBodyProps & FormComponentProps> = ({ currentTrade, onCommissionUpdated, form }) => {

    const { pricingService } = useContext(ServiceContext);

    const [loading, setLoading] = useState(false);
    const [price, setPrice] = useState<number>(0);
    const [commission, setCommission] = useState<number>(0);

    const minCommissionValue = currentTrade.tradePricing?.pricing?.commission?.officer?.full?.minValue;
    const maxCommissionValue = currentTrade.tradePricing?.pricing?.commission?.officer?.full?.maxValue;

    const officerMinCommissionValue = currentTrade.tradePricing?.pricing?.commission?.officer?.userCommissionCalculated?.minValue;
    const officerMaxCommissionValue = currentTrade.tradePricing?.pricing?.commission?.officer?.userCommissionCalculated?.maxValue;

    const officerCommissionValue = currentTrade.tradePricing?.pricing?.commission?.officer?.userCommissionCalculated?.value;
    const commissionValue = currentTrade.tradePricing?.pricing?.commission?.officer?.full?.value;

    const minCommission = officerMinCommissionValue ?? minCommissionValue
    const maxCommission = officerMaxCommissionValue ?? maxCommissionValue

    useEffect(() => {
        setCommission(officerCommissionValue ?? commissionValue);
        setPrice(currentTrade.tradePricing.pricing.price)
    }, []);



    function UpdateTrade() {
        setLoading(true);
        const request: IPricingUpdateRequest = {
            idTrade: currentTrade.id,
            price,
            commission
        };
        pricingService
            .officerUpdatePricing(request)
            .then(() => {
                ShowNotification.Success("Sucesso!", "Dados do trade alterado com sucesso");
                onCommissionUpdated(currentTrade);
            })
            .catch(error => {
                ShowNotification.Error("Erro ao atualizar Trade", error.response?.data);
            })
            .finally(() => {
                setLoading(false)
            });
    }

    return (
        <React.Fragment>
            <Spin spinning={loading}>
                <Row gutter={16}>
                    <CommissionSliderComponent
                        minCommission={minCommission}
                        maxCommission={maxCommission}
                        commission={commission}
                        minPrice={currentTrade.tradePricing.pricing.minPrice}
                        maxPrice={currentTrade.tradePricing.pricing.maxPrice}
                        price={price}
                        handleChangeValue={(p, c) => {
                            setPrice(p);
                            setCommission(c);
                        }}
                        needToPrecifyPercentLender={false}
                        canEditQuotePrice={true}
                        form={form}
                    />
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                    <div className="button-save">
                        <StandardButton
                            onClick={e => UpdateTrade()}
                            loading={loading}
                            disabled={false}
                        >
                            Salvar
                        </StandardButton>
                    </div>
                </Row>
            </Spin>
        </React.Fragment >
    );
}

export default Form.create()(CommissionBody);



// WEBPACK FOOTER //
// ./src/components/common/CommissionView/ViewCommissionModal.tsx